const ChatMessageQueryKeys = {
  global: ["chatMessages"] as const,

  forChat: (chatId: string) => [...ChatMessageQueryKeys.global, "chat", chatId],
};

export { ChatMessageQueryKeys };
